import React, { useMemo, useContext } from "react";
import { Table } from "../Table";
import ConfigContext from "../../context/ConfigContext";
import "../Table.css";

export const Table1099 = ({ data, year }) => {
	const configData = useContext(ConfigContext);

	const getReportLink = (fileName) => {
		const link = document.createElement("a");
		link.href = `${configData.REACT_APP_VIEW_1099_URL}/pdf/${fileName}`;
		document.body.appendChild(link);
		return link;
	};

	function viewReport(fileName) {
		const link = getReportLink(fileName);
		link.setAttribute("target", "_blank");
		link.click();
	};

	function exportReport(fileName) {
		const link = getReportLink(fileName);
		link.setAttribute("download", fileName);
		link.click();
	};

	const tableData = useMemo(() => data, [data]);
	const columns = useMemo(() => [
		{
			Header: "Year",
			id: 1,
			accessor: "year"
		},
		{
			Header: "1099 Type",
			id: 2,
			accessor: "type"
		},
		{
			Header: "Business Entity",
			id: 3,
			accessor: "businessEntity"
		},
		{
			Header: "View",
			id: 4,
			accessor: "fileName",
			Cell: e =>
				<div>
					<button className="btnPdf" onClick={() => viewReport(e.value)} data-testid={e.value}></button>
					<button className='link' style={{ textAlign: "right", paddingLeft: "10px" }} onClick={() => exportReport(e.value)}> Download</button>
				</div>
		}
	], []);

	return (
		<div>
			{tableData.length === 0
				? <div>No documents available for {year}. Please contact Producer Compensation.</div>
				: <Table columns={columns} data={tableData} />
			}
		</div>
	);
};